import { Icon, Tooltip, Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTablePagination from "examples/Tables/DataTable/DataTablePagination";
import React, { useEffect, useMemo, useState } from "react";
import { DatePicker } from "antd";
import { ConfigProvider, theme as antdTheme } from "antd";
import { useMaterialUIController } from "context";
import dayjs from "dayjs";
import { useAxiosPrivate } from "hooks/useAxiosPrivate";
import { OTF_STATUS } from "./steps/utils";
import { useNavigate, useSearchParams } from "react-router-dom";
import { HTTP_STATUS } from "constants/HttpStatus";
import { HTTP_STATUS_MESSAGE } from "constants/HttpStatus";
import { leadColors } from "service/Common";
import { showNotification } from "service/Notification";
import OcfDetailsModal from "./OcfDetailsModal";
const { RangePicker } = DatePicker;
const Otf = () => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const navigate = useNavigate();
  const [dates, setDates] = useState([dayjs().startOf("month"), dayjs().endOf("month")]);
  const columns = useMemo(
    () => [
      { Header: "Name", accessor: "name" },
      { Header: "Created On", accessor: "createdOn" },
      { Header: "Assigned to", accessor: "assignedTo" },
      { Header: "0TF ID", accessor: "otfid" },
      { Header: "Status", accessor: "leadState" },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );

  const [searchParams] = useSearchParams();

  const getRows = (apiData) => {
    return apiData.map((item) => ({
      name: (
        <MDTypography variant="overline" fontWeight="small">
          {item?.applicant?.name}
        </MDTypography>
      ),

      leadState: (
        <MDTypography
          variant="caption"
          fontWeight="medium"
          sx={{
            backgroundColor: leadColors[item?.leadState] || "#9e9e9e",
            color: "#fff",
            px: 1.2,
            py: 0.4,
            borderRadius: "8px",
            display: "inline-block",
            textTransform: "uppercase",
            fontSize: "11px",
            lineHeight: 1.2,
          }}
        >
          {item?.ocfStatus}
        </MDTypography>
      ),

      createdOn: (
        <MDTypography variant="overline" fontWeight="small">
          {item?.createdOn ? dayjs(item.createdOn).format("DD MMM YYYY") : ""}
        </MDTypography>
      ),

      assignedTo: (
        <MDTypography variant="overline" fontWeight="small">
          {item?.ownedBy}
        </MDTypography>
      ),

      otfid: (
        <MDTypography variant="overline" fontWeight="small">
          {item?.ocfDisplayId}
        </MDTypography>
      ),

      action: (
        <>
          <Tooltip title={"View Details"} arrow>
            <MDTypography
              component="a"
              href="#"
              color="text"
              onClick={() => openOcfDetails(item)}
              //   onClick={() => openDetailsModal(item)}
            >
              <Icon>visibility</Icon>
            </MDTypography>
          </Tooltip>

          {item?.ocfDisplayId && (
            <Tooltip title={"OTF FORM"} arrow>
              <MDTypography
                component="a"
                href="#"
                color="text"
                onClick={() => {
                  navigate(`/otf-form/${item?.ocfId}`);
                }}
              >
                <Icon>link</Icon>
              </MDTypography>
            </Tooltip>
          )}
        </>
      ),
    }));
  };
  const [ocfData, setOcfData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState("Billed");
  const [openOcfDetailsModal, setOcfDetailsModal] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const [apiParams, setApiParams] = useState({
    status: "Billed",
    startDate: dayjs().startOf("month"),
    endDate: dayjs().endOf("month"),
  });
  const [ocfDetailData, setOcfDetailsData] = useState({});
  const getOtfList = (params) => {
    let urlParams = "";
    if (params) {
      Object.keys(params).forEach(function (key, index) {
        urlParams += (index === 0 ? "?" : "&") + key + "=" + params[key];
      });
    }
    const option = {
      url: `om/ocf${urlParams}`,
      method: "get",
    };
    setLoading(true);
    axiosPrivate(option)
      .then((response) => {
        // console.log(response);
        if (
          response?.status === HTTP_STATUS.OK &&
          response?.data?.status === HTTP_STATUS_MESSAGE.OK
        ) {
          setOcfData(response?.data?.data?.list);
        } else {
          setOcfData([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        showNotification("error", "Error", "Some error occured!");
        setOcfData([]);
      });
  };

  const openOcfDetails = (id) => {
    console.log(id);
    setOcfDetailsModal(!openOcfDetailsModal);
    setOcfDetailsData(id);
  };

  useEffect(() => {
    if (searchParams.get("status")) {
      setSelectedStatus(searchParams.get("status"));
    }
    let params = apiParams;
    params.status = searchParams.get("status");
    getOtfList(params);
  }, []);

  const handleDateChange = (dates) => {
    if (!dates) return;
    const startTime = dates[0].startOf("day").valueOf();
    const endTime = dates[1].endOf("day").valueOf();
    setDates(dates);
    setApiParams({ startDate: startTime, endDate: endTime, status: selectedStatus });
    getOtfList({ startDate: startTime, endDate: endTime, status: selectedStatus });
  };
  const handleTabChange = (status) => {
    const prm = apiParams;
    prm.status = status;
    setSelectedStatus(status);
    searchParams.set("status", status);
    getOtfList(prm);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox display="flex" justifyContent="space-between" flexWrap="wrap" gap={2}>
          <MDBox display="flex" gap={2} flexWrap="wrap">
            {[
              "Draft",
              "Submitted",
              "Approved",
              "BBA Confirmed",
              "Collected",
              "Rejected",
              "Billed",
            ].map((status) => (
              <MDButton
                key={status}
                size="small"
                onClick={() => handleTabChange(status)}
                variant={selectedStatus === status ? "contained" : "outlined"}
                color={selectedStatus === status ? "success" : "info"}
              >
                {status}
              </MDButton>
            ))}
          </MDBox>
          <MDBox
            sx={{
              minWidth: { xs: "100%", sm: 220, md: 260 },
            }}
          >
            <ConfigProvider
              theme={{
                algorithm: darkMode ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
                components: {
                  DatePicker: {
                    colorBgContainer: darkMode ? "#1a2035" : "#fff",
                    colorText: darkMode ? "#fff" : "#000",
                    colorBorder: darkMode ? "#475894" : "#d9d9d9",
                    colorBgElevated: darkMode ? "#1f2937" : "#fff",
                    colorPrimary: darkMode ? "#1890ff" : "#1890ff",
                  },
                },
              }}
            >
              <RangePicker
                value={dates}
                onChange={handleDateChange}
                style={{ minWidth: 250 }}
                allowClear={false}
              />
            </ConfigProvider>
          </MDBox>
        </MDBox>
      </MDBox>

      <Grid item xs={12} py={4}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <MDTypography variant="h6" color="white">
              OTF
            </MDTypography>
            {/* <MDTypography variant="h6" color="white"></MDTypography> */}
          </MDBox>
          <MDBox pt={3}>
            <DataTablePagination
              table={{
                columns,
                rows: getRows(ocfData),
                totalCount,
                pageCount: Math.ceil(totalCount / pageSize),
              }}
              loading={loading}
              page={page}
              pageSize={pageSize}
              //   onPageChange={(p) => {
              //     setPage(p);
              //     getLeadsData(p, searchParams.get("status"), searchParams.get("employeeId"));
              //   }}
              //   onPageSizeChange={(s) => {
              //     console.log(s);
              //   }}
            />
          </MDBox>
        </Card>
      </Grid>

      {openOcfDetailsModal && (
        <OcfDetailsModal open={openOcfDetailsModal} onClose={openOcfDetails} data={ocfDetailData} />
      )}
    </DashboardLayout>
  );
};

export default Otf;
